import WebTableColumnsModal from './web-table-columns-modal.vue'
export default WebTableColumnsModal
